module.exports = __webpack_public_path__ + "img/ll@2x.8155c28c.png";